// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.MdBubbleChart = function MdBubbleChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "7.2",
        "cy": "14.4",
        "r": "3.2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.8",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.2",
        "cy": "8.8",
        "r": "4.8"
      }
    }]
  })(props);
};